import axios from "axios";
import { BaseResponse } from "../common/interfaces/responses";
import { getErrorMsg } from "../common/utils/http";

export default function setupPaidPlatformAnnouncement() {
	const { findHtmlEl, findLinkEl } = pm.utils.dom;

	window.addEventListener("load", function () {
		const popup = findHtmlEl(".paid-platform-anouncement-popup");
		if (!popup) return;

		pm.event.emit("pm_open_popup_via_api", {
			name: "paid-platform-anouncement",
		});
	});

	const markAsReadButton = findLinkEl(
		".paid-platform-anouncement-popup .mark-as-read",
	);

	if (markAsReadButton) {
		markAsReadButton.addEventListener("click", async function (e) {
			e.preventDefault();

			this.classList.add("is-loading");
			const response = await markAsRead();
			this.classList.remove("is-loading");
			window.location.href = this.href;
		});
	}

	async function markAsRead() {
		const formData = new FormData();

		formData.append("action", "pm_read_paid_platform_announcement");

		try {
			const axiosResponse = await axios<BaseResponse>({
				method: "post",
				url: pm.ajaxurl,
				data: formData,
			});

			return axiosResponse.data;
		} catch (response: any) {
			return {
				success: false,
				message: getErrorMsg(response),
			};
		}
	}
}
